import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DatadogService {

  servicesOptions: any;

  constructor(private _http: HttpClient) { }

  getHttp() {
    this.servicesOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
        'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
  }

  getEmbeddedGraph(payload) {
    this.getHttp();
    return this._http.post(environment.serviceshost + '/v1/generateDatadogEmbed', payload, this.servicesOptions)
        .pipe(map(res => res));
  }
}
